import { render, staticRenderFns } from "./UsuarioGrupoLista.vue?vue&type=template&id=331c19c0&scoped=true"
import script from "./UsuarioGrupoLista.vue?vue&type=script&lang=js"
export * from "./UsuarioGrupoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c19c0",
  null
  
)

export default component.exports